import React from "react";
import { Badge } from "../UI/Index";
import { BadgeVariant } from "../UI/Types";
import "./Style.scss";

/**
 * Returns the badge
 * @param extractVersion extract version
 * @param displayText text to display
 * @returns Badge with latest label
 */
export const GetTextWithVersionBadge = (extractVersion: string, displayText: string): JSX.Element => {
  return (
    <div className="ebt-badge__container">
      <div className="ebt-badge__text-overflow">{displayText}</div>
      <div
        className="ebt-badge"
        title="Version information"
      >
        <Badge value={extractVersion} variant={BadgeVariant.Primary} />
      </div>
    </div>
  );
};
